"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastMessageContextProvider = exports.ToastMessageContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 */
exports.ToastMessageContext = react_1.createContext({
    messages: [],
    removeMessage: function () {
        /*do nothing*/
    },
    removeAllMessages: function () {
        /*do nothing*/
    },
    addMessage: function () {
        /*do nothing*/
        return "";
    },
});
var idCounter = 0;
var DEFAULT_DURATION = 2500;
/**
 * @internal
 */
exports.ToastMessageContextProvider = function (_a) {
    var children = _a.children;
    var _b = tslib_1.__read(react_1.useState([]), 2), messages = _b[0], setMessages = _b[1];
    var removeMessage = function (id) {
        setMessages(function (prevMessages) { return prevMessages.filter(function (message) { return message.id !== id; }); });
    };
    var removeAllMessages = function () {
        setMessages([]);
    };
    var addMessage = function (message) {
        var _a;
        var id = (++idCounter).toString(10);
        var newMessage = tslib_1.__assign(tslib_1.__assign({}, message), { id: id });
        setMessages(function (prevMessages) { return tslib_1.__spread(prevMessages, [newMessage]); });
        var duration = (_a = message.duration) !== null && _a !== void 0 ? _a : DEFAULT_DURATION;
        if (duration) {
            setTimeout(function () {
                removeMessage(newMessage.id);
            }, duration);
        }
        return id;
    };
    return (react_1.default.createElement(exports.ToastMessageContext.Provider, { value: { messages: messages, removeMessage: removeMessage, removeAllMessages: removeAllMessages, addMessage: addMessage } }, children));
};
//# sourceMappingURL=ToastMessageContext.js.map